module.exports = __webpack_public_path__ + "img/bush.667f0685.svg";